import { practice } from "../../data/practice";
import { buildPostalAddress } from "./practiceEntity";
import { buildSeoPageGraph } from "./pageGraph";
import { PATH_PRACTICE } from "../../utils/constants";

const PRACTICE_PLACE_DESCRIPTION =
  "Ruhige, reizarme Praxisräume für ergotherapeutische Behandlungen. Ausgestattet mit Sprossenwand, Therapieliege und modernen Therapiematerialien.";

export function buildPracticePlaceGraph() {
  const base = buildSeoPageGraph(PATH_PRACTICE, "praxis", {
    description: PRACTICE_PLACE_DESCRIPTION,
  });

  base["@graph"].push({
    "@type": "Place",
    "@id": `${practice.baseUrl}${PATH_PRACTICE}#place`,
    name: "Ergotherapie Rottweil - Praxisräume",
    description: PRACTICE_PLACE_DESCRIPTION,
    address: buildPostalAddress(),
    amenityFeature: [
      { "@type": "LocationFeatureSpecification", name: "Therapieraum mit Sprossenwand" },
      { "@type": "LocationFeatureSpecification", name: "Besprechungsraum" },
      { "@type": "LocationFeatureSpecification", name: "Moderne Therapiematerialien" },
    ],
  });

  return base;
}
